import React, { useEffect, useRef, useState } from 'react';
import { Button, Form, Message, Table } from 'semantic-ui-react';
import { request, time } from './helpers';
import { entryKinds, financeQuery, financeYuan } from './finance';
const empty = {
  from: '',
  to: '',
  user_id: '',
  actor_id: '',
  kind: '',
  business_id: '',
};
export default function WalletLedger({ refresh }) {
  const [draft, setDraft] = useState(empty),
    [filters, setFilters] = useState(empty),
    [page, setPage] = useState(0),
    [data, setData] = useState(null),
    [error, setError] = useState(''),
    [loading, setLoading] = useState(false);
  const latest = useRef(0);
  useEffect(() => {
    const version = ++latest.current;
    setLoading(true);
    setError('');
    setData(null);
    let query;
    try {
      query = financeQuery({ ...filters, page });
    } catch (e) {
      setError(e.message);
      setLoading(false);
      return;
    }
    request('get', `/api/platform/admin/ledger?${query}`)
      .then((value) => {
        if (version === latest.current) setData(value);
      })
      .catch((e) => {
        if (version === latest.current) setError(e.message);
      })
      .finally(() => {
        if (version === latest.current) setLoading(false);
      });
    return () => {
      latest.current++;
    };
  }, [filters, page, refresh]);
  return (
    <>
      <h2>钱包流水</h2>
      <p>
        展示真实钱包变动，包含充值、扣费、预占、释放和人工核算。预占与释放不作为经营收支。
      </p>
      <Form
        className='finance-filter'
        onSubmit={() => {
          setFilters({ ...draft });
          setPage(0);
        }}
      >
        <Form.Group widths='equal'>
          <Form.Input
            type='date'
            id='ledger-from'
            label='开始日期（北京时间）'
            value={draft.from}
            onChange={(e) => setDraft({ ...draft, from: e.target.value })}
          />
          <Form.Input
            type='date'
            id='ledger-to'
            label='结束日期'
            value={draft.to}
            onChange={(e) => setDraft({ ...draft, to: e.target.value })}
          />
          <Form.Input
            type='number'
            min='1'
            id='ledger-user'
            label='用户 ID'
            value={draft.user_id}
            onChange={(e) => setDraft({ ...draft, user_id: e.target.value })}
          />
          <Form.Input
            type='number'
            min='0'
            id='ledger-actor'
            label='操作人 ID（0 为系统）'
            value={draft.actor_id}
            onChange={(e) => setDraft({ ...draft, actor_id: e.target.value })}
          />
        </Form.Group>
        <Form.Group widths='equal'>
          <Form.Select
            id='ledger-kind'
            label='流水类型'
            value={draft.kind}
            options={[
              { key: 'all', value: '', text: '全部类型' },
              ...Object.entries(entryKinds).map(([value, text]) => ({
                key: value,
                value,
                text,
              })),
            ]}
            onChange={(_, value) => setDraft({ ...draft, kind: value.value })}
          />
          <Form.Input
            id='ledger-business'
            label='业务编号（包含匹配）'
            value={draft.business_id}
            onChange={(e) =>
              setDraft({ ...draft, business_id: e.target.value })
            }
          />
        </Form.Group>
        <Button primary type='submit' loading={loading}>
          筛选
        </Button>
        <Button
          type='button'
          onClick={() => {
            setDraft(empty);
            setFilters({ ...empty });
            setPage(0);
          }}
        >
          重置
        </Button>
      </Form>
      {error && <Message negative content={error} />}{' '}
      {loading && <p role='status'>正在加载流水…</p>}
      {data && (
        <>
          <p>共 {data.total} 条匹配流水</p>
          <div className='platform-scroll'>
            <Table unstackable basic='very'>
              <Table.Header>
                <Table.Row>
                  {[
                    '时间',
                    '用户',
                    '操作人',
                    '类型',
                    '金额变动',
                    '余额',
                    '原因',
                    '业务编号',
                  ].map((name) => (
                    <Table.HeaderCell key={name}>{name}</Table.HeaderCell>
                  ))}
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {data.items.map((row) => (
                  <Table.Row key={row.id}>
                    <Table.Cell>{time(row.created_at)}</Table.Cell>
                    <Table.Cell>{row.user_id}</Table.Cell>
                    <Table.Cell>{row.actor_id || '系统'}</Table.Cell>
                    <Table.Cell>{entryKinds[row.kind] || row.kind}</Table.Cell>
                    <Table.Cell
                      style={{
                        whiteSpace: 'nowrap',
                        color: row.amount < 0 ? '#c45147' : '#2b8965',
                      }}
                    >
                      {financeYuan(row.amount)}
                    </Table.Cell>
                    <Table.Cell style={{ whiteSpace: 'nowrap' }}>
                      {financeYuan(row.balance)}
                    </Table.Cell>
                    <Table.Cell>{row.reason}</Table.Cell>
                    <Table.Cell>
                      <code>{row.business_id}</code>
                    </Table.Cell>
                  </Table.Row>
                ))}
              </Table.Body>
            </Table>
          </div>
          {data.items.length === 0 && (
            <Message content='当前筛选范围内没有钱包流水' />
          )}
          <div className='finance-pagination'>
            <Button
              disabled={page === 0 || loading}
              onClick={() => setPage((value) => value - 1)}
            >
              上一页
            </Button>
            <span>
              第 {page + 1} / {Math.max(1, Math.ceil(data.total / 50))} 页
            </span>
            <Button
              disabled={(page + 1) * 50 >= data.total || loading}
              onClick={() => setPage((value) => value + 1)}
            >
              下一页
            </Button>
          </div>
        </>
      )}
    </>
  );
}
